// "My Profile" sidebar destination — has no UI of its own. Loads the doctor's
// listing and forwards straight to the full-page profile editor, since a
// doctor's dashboard is scoped to a single practice today (no listing picker).
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";
import { loadMyListingsFn } from "./-dashboard.doctor.functions";

export const Route = createFileRoute("/dashboard/doctor_/profile")({
  component: DoctorProfileRedirect,
});

function DoctorProfileRedirect() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate({ to: "/login", replace: true }); return; }
    (async () => {
      const mine = (await loadMyListingsFn()) ?? [];
      if (mine.length === 0) {
        navigate({ to: "/dashboard/new-listing", search: {} as any, replace: true });
        return;
      }
      navigate({ to: "/dashboard/doctor/edit/$id", params: { id: (mine[0] as any).id }, search: {}, replace: true });
    })();
  }, [user, loading, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground gap-2">
      <Loader2 className="h-4 w-4 animate-spin" /> Loading your profile…
    </div>
  );
}
